<div class='e-btn-group' [formGroup]="form" [ngClass]="{
  'disabled': form.controls.formValue.disabled
}">
  <input type="radio" id="{{id}}-yes" formControlName="formValue" [value]="true" />
  <label class="e-btn" for="{{id}}-yes">{{ yesLabel | translate}}</label>
  <input type="radio" id="{{id}}-no" formControlName="formValue" [value]="false" />
  <label class="e-btn" for="{{id}}-no">{{ noLabel | translate}}</label>
</div>